// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2rTRH","title":"Images90_title__3CmeU","images":"Images90_images__28HKB"};